import axios from '@/_utils/axios';
import Toggle from '@/components/_common/Toggle/Toggle';
import { useConfigValue } from '@/components/_hooks/useConfigValue';
import { Order } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';
import React, { useMemo, useState } from 'react';

interface AutoSubmitToggleProps {
  order: Order;
  disabled: boolean;
  setOrder: React.Dispatch<React.SetStateAction<Order>>;
}

const AutoSubmitToggle = ({ order, disabled, setOrder }: AutoSubmitToggleProps) => {
  const [loading, setLoading] = useState(false);
  const isDisabled = useMemo(() => disabled || loading, [loading, disabled]);
  const ordersApiVersion = useConfigValue(['bulkOrderEditVersion']) || 1;

  const handleAutoSubmitToggle = (newValue: boolean) => {
    setLoading(true);
    axios
      .post(`/core/orders/${order.id}/`, { auto_submit_jobs: newValue }, ordersApiVersion === 2 ? { baseURL: '/api/v2/' } : undefined)
      .then((res) => setOrder(res.data.data))
      .catch((error) => console.error('Error toggling auto submit:', error))
      .finally(() => setLoading(false));
  };

  return (
    <ToggleWrapper disabled={+isDisabled} checked={+!!order?.auto_submit_jobs}>
      <Toggle disabled={isDisabled} value={order?.auto_submit_jobs || false} onChange={() => handleAutoSubmitToggle(!order?.auto_submit_jobs)} />
      <span>Auto-submit jobs</span>
    </ToggleWrapper>
  );
};

export default AutoSubmitToggle;

const ToggleWrapper = styled.div<{ disabled: number; checked: number }>`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing(1.5)};
  height: 100%;
  width: fit-content;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  padding: ${({ theme }) => theme.spacing(2, 3)};
  margin-left: auto;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  span {
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    font-size: 1rem;
  }

  ${({ theme, checked }) =>
    theme.palette.mode === 'light' &&
    `
    > div {
      background: ${checked ? theme.palette.primary.main : theme.palette.default.main};
      > div {
        background: #ffffff;
      }
    }
  `}
`;
